/**
 * @flow
 * @relayHash a00f8de8add6c8021c861733cb590d62
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TaxContextQueryVariables = {||};
export type TaxContextQueryResponse = {|
  +taxs: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: ?string,
        +name: string,
        +requiresManualInput: ?boolean,
      |}
    |}>
  |}
|};
export type TaxContextQuery = {|
  variables: TaxContextQueryVariables,
  response: TaxContextQueryResponse,
|};
*/


/*
query TaxContextQuery {
  taxs(orderBy: [code], order: ASC) {
    edges {
      node {
        id
        name
        requiresManualInput
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "taxs",
    "storageKey": "taxs(order:\"ASC\",orderBy:[\"code\"])",
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "code"
        ]
      }
    ],
    "concreteType": "TaxConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "TaxEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Tax",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "requiresManualInput",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TaxContextQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "TaxContextQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "TaxContextQuery",
    "id": null,
    "text": "query TaxContextQuery {\n  taxs(orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        name\n        requiresManualInput\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '09d45833e6afc7a12cd68568064d32c9';
module.exports = node;
